import React from 'react';
import styles from './FichaColumnas.module.css';

export const FichaColumnas = ({
  children,
  width = '95%',
  mobileWidth = '98%',
  align = 'stretch',
  mobileAlign = 'center',
  justify = 'space-evenly',
  gap = '0.5rem',
}) => {
  const styleVars = {
    '--fila-width': width,
    '--fila-mobile-width': mobileWidth,
    '--fila-align': align,
    '--fila-mobile-align': mobileAlign,
    '--fila-justify': justify,
    '--fila-gap': gap,
  };

  return (
    <div className={styles.fila} style={styleVars}>
      {children}
    </div>
  );
};

export const FichaColumna = ({
  children,
  width = '100%',
  mobileWidth = '100%',
  align = 'stretch',
  mobileAlign = 'stretch',
  padding = '0 0 1rem 1rem',
  mobilePadding = '0',
  gap = '0',
}) => {
  const styleVars = {
    '--col-width': width,
    '--col-mobile-width': mobileWidth,
    '--col-align': align,
    '--col-mobile-align': mobileAlign,
    '--col-padding': padding,
    '--col-mobile-padding': mobilePadding,
    '--col-gap': gap,
  };

  return (
    <div className={styles.columna} style={styleVars}>
      {children}
    </div>
  );
};
